import { Button } from "react-bootstrap";

const ReferralCard = ({
  person,
  isHovered,
  onConnect,
  onHover,
  onLeave,
  cardPosition,
}) => {
  return (
    <div
      className="col-12 col-md-6 col-lg-3 d-flex justify-content-center position-relative mb-4"
      onMouseEnter={onHover}
      onMouseLeave={onLeave}
    >
      {/* Main Card */}
      <div className="card border-0 shadow-sm text-center referral-card">
        <img
          src={person.image || "/placeholder.png"}
          alt={person.name || "No Name"}
          className="card-img-top rounded-circle border"
          style={{
            width: "150px",
            height: "150px",
            objectFit: "cover",
            margin: "15px auto 10px",
            display: "block",
          }}
        />
        <div className="card-body p-2">
          <h6 className="text-secondary mb-1">{person.name || "Unnamed"}</h6>
          <p className="text-secondary small mb-2">
            {person.role || "Role unknown"}
          </p>
          <Button size="sm" variant="primary" onClick={() => onConnect(person)}>
            Connect
          </Button>
        </div>
      </div>

      {/* Hover Card */}
      {isHovered && (
        <div
          className={`hover-card shadow p-3 bg-secondary rounded ${
            cardPosition === "last" ? "hover-left" : "hover-right"
          }`}
        >
          {person.linkedin && (
            <p className="mb-1">
              <b>LinkedIn:</b>{" "}
              <a
                href={person.linkedin}
                target="_blank"
                rel="noreferrer"
                className="text-decoration-none"
              >
                View Profile
              </a>
            </p>
          )}
          {person.company && (
            <p className="mb-1">
              <b>Working At:</b> {person.company}
            </p>
          )}
          {person.email && (
            <p className="mb-1">
              <b>Email:</b> {person.email}
            </p>
          )}
          {person.experience && (
            <p className="mb-1">
              <b>Experience:</b> {person.experience}
            </p>
          )}
          <p className="mb-0">
            <b>Role:</b> {person.role || "N/A"}
          </p>
        </div>
      )}
    </div>
  );
};

export default ReferralCard;
